import React from 'react';
import { TextField } from '@zep-us/zus';
import { logger } from '@zep/core-logger';
import { QUIZ_SET_TITLE_MAX_LENGTH } from '@/views/build/form/schema';
import { useQuizTitle } from '../../features/build-quiz-title';
import { useFocusTarget } from '../focus/useFocusTarget';
import { CategoryInfoDisplay } from './CategoryInfoDisplay';
import { SelectMapTemplateField } from './SelectMapTemplateField';
export const MapAndCategoryInfoSection = () => {
  const {
    title,
    updateTitle,
    titlePlaceholder
  } = useQuizTitle();
  const titleFieldRef = useFocusTarget<HTMLInputElement>('title');
  return <div className="flex flex-col gap-md" data-sentry-component="MapAndCategoryInfoSection" data-sentry-source-file="MapAndCategoryInfoSection.tsx">
      <SelectMapTemplateField data-sentry-element="SelectMapTemplateField" data-sentry-source-file="MapAndCategoryInfoSection.tsx" />
      <TextField.Root required data-sentry-element="unknown" data-sentry-source-file="MapAndCategoryInfoSection.tsx">
        <TextField.Input intent="strong" autoFocus maxLength={QUIZ_SET_TITLE_MAX_LENGTH} placeholder={titlePlaceholder} value={title || ''} onChange={e => {
        updateTitle(e.target.value);
      }} ref={titleFieldRef} onBlur={() => {
        logger.track('quiz_set_title_change', {
          location: 'settings_page'
        });
      }} data-sentry-element="unknown" data-sentry-source-file="MapAndCategoryInfoSection.tsx" />
      </TextField.Root>
      <CategoryInfoDisplay data-sentry-element="CategoryInfoDisplay" data-sentry-source-file="MapAndCategoryInfoSection.tsx" />
    </div>;
};